import Swiper from "swiper";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {German} from "flatpickr/dist/l10n/de.js";

class Hero {
  constructor() {
    this.init();
  }

  init() {
    this.slider();
    this.setupLinkClicks();
    this.handleMEWS();
    this.handleDatePicker();
  }

  slider() {
    this.swiper = new Swiper(".hero-main-swiper", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 1000,
      slidesPerView: 1,
      effect: "fade",
      allowTouchMove: false,
    });

    this.swiper.on('slideChange', () => {
      this.updateActiveLink();
    });
  }

  setupLinkClicks() {
    window.addEventListener('click', (event) => {
      const link = event.target;

      if (!link.classList.contains('hero-main-link')) {
        return;
      }

      const activeIndex = link.dataset.slide;

      this.swiper.slideTo(Number(activeIndex));

      this.updateActiveLink();
    });
  }

  updateActiveLink() {
    const links = document.querySelectorAll('.hero-main-link');
    const activeIndex = this.swiper.realIndex;

    links?.forEach(link => link.classList.remove('active'));

    links?.forEach(link => {
      const slideIndex = link.dataset.slide;

      if (Number(slideIndex) === activeIndex) {
        link.classList.add('active');
      }
    });
  }

  handleMEWS() {
    try {
      const buttonSend = document.querySelector('.hero-service__action-button');
      const heroService = document.querySelector('.hero-service');

      if (!heroService) {
        return;
      }

      if (!buttonSend) {
        return;
      }

      const mode = heroService.getAttribute('data-mode');
      const tokenMews = mode === 'meet' ? backendData.tokenMeet : backendData.tokenSleep;

      buttonSend.addEventListener('click', () => {
        this.openWidget(tokenMews);
      });

    } catch (error) {
      console.error('Error in handleMEWS:', error);
    }
  }

  handleDatePicker() {
    const checkInInput = document.querySelector(".check-in .service_action-datepicker-value");
    const checkOutInput = document.querySelector(".check-out .service_action-datepicker-value");
    const heroServiceContainer = document.querySelector(".hero-service__actions-wrap");
    const isSleep = heroServiceContainer?.classList.contains('sleep');

    const commonOptions = {
      mode: "single",
      enableTime: !isSleep,
      time_24hr: true,
      minuteIncrement: 60,
      dateFormat: isSleep ? "d/m/Y" : "d/m/Y H:i",
      minDate: new Date(),
      locale: German,
      placeholder: 'mm/dd/yyyy',
      onReady: (selectedDates, dateStr, instance) => {
        instance.calendarContainer.classList.add("meet-flatpickr-calendar");
      }
    };

    const checkInPicker = flatpickr(".hero-service_action-datepicker.check-in", {
      ...commonOptions,
      onChange: (selectedDates, dateStr, instance) => {
        this.handleDateChange(selectedDates, checkInInput, 'En', isSleep);

        if (selectedDates.length > 0) {
          const minCheckOutDate = new Date(selectedDates[0]);
          if (isSleep) {
            minCheckOutDate.setDate(minCheckOutDate.getDate() + 1);
          } else {
            minCheckOutDate.setHours(minCheckOutDate.getHours() + 1);
          }

          if (checkOutPicker.selectedDates[0] && checkOutPicker.selectedDates[0] < minCheckOutDate) {
            checkOutPicker.clear();
            checkOutInput.textContent = 'Check-out';
          }
          checkOutPicker.set('minDate', minCheckOutDate)
        }
      }
    });

    const checkOutPicker = flatpickr(".hero-service_action-datepicker.check-out", {
      ...commonOptions,
      onChange: (selectedDates) => this.handleDateChange(selectedDates, checkOutInput, 'En', isSleep)
    });


    this.checkInPicker = checkInPicker;
    this.checkOutPicker = checkOutPicker;
  }

  handleDateChange = (selectedDates, inputElement, currentLang, isSleep) => {
    if (selectedDates.length === 1) {
      const localeFormat = currentLang === "De" ? "de-DE" : "en-GB";
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      };

      if (!isSleep) {
        options.hour = "2-digit";
        options.minute = "2-digit";
      }

      inputElement.textContent = selectedDates[0].toLocaleString(localeFormat, options);
    }
  };

  openWidget(token) {
    Mews.Distributor(
      {
        configurationIds: [token],
      },
      function (api) {
        const getDateValue = (selector) =>
          document.querySelector(`${selector} .service_action-datepicker-value`)?.textContent || '';

        const checkInDate = getDateValue('.check-in').replace(/\./g, '/');
        const checkOutDate = getDateValue('.check-out').replace(/\./g, '/');

        const currentLang = document.querySelector("body").dataset.lang;
        const languageCode = currentLang === 'De' ? 'de-DE' : 'en-US';
        api.setLanguageCode(languageCode);

        api.open();

        if (checkInDate && checkOutDate) {
          const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, day);
          };

          setTimeout(() => {
            api.setStartDate(parseDate(checkInDate));
            api.setEndDate(parseDate(checkOutDate));
          }, 100);
        }
      }
    );
  }
}

new Hero();